export default [
  {
    path: '/dorecharge',
    name: 'dorecharge',
    component: () => import('../../views/dorecharge/index.vue'),
    meta: {
      auth: true,
      title: '充值释放',
      keepAlive: true,
      headerTheme: 'dark'
    }
  }
]

